import { useState, createContext } from 'react'


export const LeftPanelContext = createContext<any>(null)

const LeftPanelProvider = ({ children }: any) => {
    const [left, setLeft] = useState<string>('')

    return (
        <LeftPanelContext.Provider value={{ left, setLeft }}>
            {children}
        </LeftPanelContext.Provider>
    )
}

export default LeftPanelProvider